import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { USBCheckboxBase } from '@usb-shield/react-forms-base'
import USBModal from '../../../../../components/modal-wrapper/index'
import { PageviewTealiumEvent } from '../../../../../utils/tealiumwrapper'
import { PAGE_NAMES } from '../../../../../constants/tealiumData'
import onKeyDownHelper from '../../../../../utils/onKeyDownHelper'
import './findBills.scss'
// import { useMultilingualService } from '../../../../service/multilingualService'

const FindBillsModal = ({
  findBillsModal,
  onContinue,
  onClose,
  findBillsTerms,
  setFindBillsTerms,
  findBillsTermsError,
  handleAnchorClick
}) => {
  useEffect(() => {
    if (findBillsModal) {
      document.title = 'Find bills'
      PageviewTealiumEvent(PAGE_NAMES.FIND_BILL_DASHBOARD, {
        consentPopup: true
      })
    }
  }, [findBillsModal])

  return (
    <USBModal
      isOpen={findBillsModal}
      handleModalClose={onClose}
      wrapID="readytosend-popup-modal"
      zIndex="1050"
      modalTitle={
        <p className="usb-tg-subheader-large usb-c-usb-blue">
          Let us find your bills
        </p>
      }
      footerButtonOptions={[
        {
          type: 'primary',
          text: 'Continue',
          id: 'findbills-continue-btn',
          clickEvent: onContinue
        },
        {
          type: 'secondary',
          text: 'Cancel',
          id: 'findbills-cancel-btn',
          clickEvent: onClose
        }
      ]}
    >
      <article className="usb-tg-body-medium usb-c-gray-80">
        <p>
          <span>
            We search our merchant networks and use information from your credit
            report to help you identify and choose which bills to add. Our
            search only finds bills and doesn’t impact your credit. Your account
            information is safe and secure, and it’s never shared with any
            merchants.
          </span>{' '}
          <button
            type="button"
            className="findBills__termsOfServiceLinkStyle usb-c-interaction-blue"
            onClick={handleAnchorClick}
            onKeyDown={(e) => onKeyDownHelper(e, handleAnchorClick)}
          >
            View full terms of service
          </button>
        </p>

        <section style={{ marginTop: '1rem' }}>
          <USBCheckboxBase
            inputName="setFinalPaymentCheckbox"
            labelText="I give authorization to find bills for me using info from my
                credit report."
            dynamicValue={findBillsTerms}
            isRequired
            statusUpdateCallback={(data) => {
              setFindBillsTerms(data.inputValue)
            }}
          />
          {findBillsTermsError && (
            <p style={{ marginTop: '5px', color: 'red' }}>
              {findBillsTermsError}
            </p>
          )}
        </section>
      </article>
    </USBModal>
  )
}

FindBillsModal.propTypes = {
  findBillsModal: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  findBillsTerms: PropTypes.bool.isRequired,
  setFindBillsTerms: PropTypes.func.isRequired,
  findBillsTermsError: PropTypes.bool.isRequired,
  handleAnchorClick: PropTypes.func.isRequired
}

export default FindBillsModal
